import { Alert } from 'reactstrap';

/**
 * #116 — Gemeinsamer Guard fuer API-Produkt-Seiten.
 *
 * Zeigt einen einheitlichen Hinweis, wenn der BFF-Proxy des Produkts nicht
 * konfiguriert ist (statt eines leeren/kaputten Screens), sonst die Inhalte.
 * Ersetzt die pro Seite kopierte lokale `ProxyGuard`-Funktion (~13 Stellen).
 *
 * @param {object} p
 * @param {boolean} p.enabled   Ergebnis von is<Produkt>ProxyEnabled().
 * @param {string}  p.label     Anzeigename (z. B. "ebill").
 * @param {string}  p.envVar    Env-Var, die den Proxy aktiviert (z. B. EBILL_API_URL).
 * @param {string}  p.proxyPath BFF-Pfad (z. B. /proxy/ebill).
 */
export function ApiProxyGuard({ enabled, label, envVar, proxyPath, children }) {
  if (!enabled) {
    return (
      <Alert color="secondary" className="small">
        <strong>{label}-Proxy nicht konfiguriert.</strong> Setze <code>{envVar}</code>
        {' '}auf dem Orbit-Frontend, damit der BFF <code>{proxyPath}</code> aktiv wird.
      </Alert>
    );
  }
  return children;
}
